import { render, staticRenderFns } from "./ticketdetail.vue?vue&type=template&id=e7c0ac28&"
import script from "./ticketdetail.vue?vue&type=script&lang=js&"
export * from "./ticketdetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports